// extracted by mini-css-extract-plugin
export default {"mintId":"MintIdBanner_mintId__1S44T","mintIdBtn":"MintIdBanner_mintIdBtn__QrqX9","min":"MintIdBanner_min__4kwyY"};